class StickyNavigation {
  constructor() {
    this.nav = document.querySelector('.sticky-nav');
    this.lastScrollTop = 0;
    this.delta = 5;
    this.navbarHeight = this.nav.offsetHeight;
    this.didScroll = false;
    this.init();
  }

  init() {
    window.addEventListener('scroll', () => { this.didScroll = true; });
    setInterval(() => {
      if (this.didScroll) {
        this.hasScrolled();
        this.didScroll = false;
      }
    }, 250);
  }

  hasScrolled() {
    const st = window.scrollY;
    if (Math.abs(this.lastScrollTop - st) <= this.delta) return;
    if (st > this.navbarHeight) {
      this.nav.classList.add('scrolled-past-header');
    } else {
      this.nav.classList.remove('scrolled-past-header');
    }
    if (st > this.lastScrollTop && st > this.navbarHeight) {
      this.nav.classList.remove('nav-down');
      this.nav.classList.add('nav-up');
    } else if (st + window.innerHeight < document.documentElement.scrollHeight) {
      this.nav.classList.remove('nav-up');
      this.nav.classList.add('nav-down');
    }
    this.lastScrollTop = st;
  }
}

document.addEventListener('DOMContentLoaded', () => { new StickyNavigation(); });
